import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "application-component" }
const _hoisted_2 = {
  key: 0,
  class: "placeholder"
}

import { computed, onMounted } from "vue"
import { jsonParse } from '@/utils'
import { useGlobalStore } from '@/store/modules/global'


export default {
  __name: 'Terminology',
  props: {
  readOnly: {
    type: Boolean,
    default: false
  },
  data: {
    type: Object,
    default: () => null,
  },
  projectId: {
    type: String,
    default: ''
  },
  handleAddToDetailList: {
    type: Function,
    default: () => null
  },
  handleUpdateDetailList: {
    type: Function,
    default: () => null
  }
},
  setup(__props) {

const globalStore = useGlobalStore()

const props = __props

let resizeObserver = null
const wrap = ref(null)
const wrapWidth = ref()

const fontSize = computed(() => `${globalStore.fontSize}px`)
const tableData = computed(() => {
  return jsonParse(props.data?.docResult)
})

const getPageScale = () => {
  // 获取设备像素比率
  const devicePixelRatio = window.devicePixelRatio || 1
  
  // 获取浏览器缩放比例
  const browserZoom = window.visualViewport ? window.visualViewport.scale : 1
  
  // 计算实际展示比率
  const actualScale = devicePixelRatio * browserZoom
  
  return actualScale
  
}

const columnWidth = computed(() => {
  if (!wrapWidth.value) return { term: 110, englishExpression: 150, AIExplanation: 150, scrollX: 410 }
  
  const availableWidth = wrapWidth.value
  const term = Math.max(availableWidth * 0.2, 110)
  const englishExpression = Math.max(availableWidth * 0.35, 150)
  const AIExplanation = Math.max(availableWidth * 0.45, 150)
  
  return { term, englishExpression, AIExplanation, scrollX: term + englishExpression + AIExplanation }
})

onMounted(() => {
  wrapWidth.value = wrap.value?.clientWidth
  // 监听wrap宽度变化
  resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      if (entry.target === wrap.value) {
        wrapWidth.value = entry.contentRect.width
      }
    }
  })
  if (wrap.value) {
    resizeObserver.observe(wrap.value)
  }
})

onUnmounted(() => {
  if (resizeObserver && wrap.value) {
    resizeObserver.unobserve(wrap.value)
    resizeObserver.disconnect()
  }
})

return (_ctx, _cache) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "application-component-title" }, "术语表", -1)),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "application-component-content",
      ref_key: "wrap",
      ref: wrap,
      "element-loading-text": "正在思考中..."
    }, [
      (__props.readOnly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_skeleton, {
              rows: 2,
              animated: ""
            })
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "content textselection",
            style: _normalizeStyle({fontSize: fontSize.value})
          }, [
            _createVNode(_component_el_table, {
              data: tableData.value,
              "max-height": _unref(wrap)?.clientHeight ? (_unref(wrap)?.clientHeight - 24) : '100%',
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "term",
                  label: "术语",
                  width: columnWidth.value.term,
                  fixed: ""
                }, null, 8, ["width"]),
                _createVNode(_component_el_table_column, {
                  prop: "englishExpression",
                  label: "英文表达",
                  width: columnWidth.value.englishExpression
                }, null, 8, ["width"]),
                _createVNode(_component_el_table_column, {
                  prop: "AIExplanation",
                  label: "AI解读",
                  width: columnWidth.value.AIExplanation
                }, null, 8, ["width"])
              ]),
              _: 1
            }, 8, ["data", "max-height"])
          ], 4))
    ])), [
      [_directive_loading, !__props.readOnly && !__props.data]
    ])
  ]))
}
}

}